import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import NebraskaTVImg from '../images/NetworkingSessions.jpg';

import '../styles/FeaturedPress.css';

const additionalCoverage = [
  {
    id: 'agtech-success-midwest',
    outlet: 'AgNavigator',
    type: 'Research Coverage',
    date: 'August 4, 2026',
    title:
      'Agtech Success Is Built, Not Inherited, Says Midwest Innovation Study',
    description:
      'A new University of Nebraska–Lincoln study finds that agricultural strength alone does not guarantee AgTech startup growth or investment. Successful regions deliberately build capital, commercialization pathways, startup infrastructure, and stronger connections between researchers, entrepreneurs, investors, industry, and farmers.',
    url:
      'https://www.agnavigator.com/Article/2026/08/04/agtech-success-is-built-not-inherited-says-midwest-innovation-study/',
  },

  {
    id: 'startup-sandbox',
    outlet: 'Silicon Prairie News',
    type: 'Feature',
    date: 'June 30, 2026',
    title:
      'Global AgTech Startups Choose Nebraska in New Spur Startup Sandbox Validation Program',
    description:
      'Four international startups will work with University of Nebraska–Lincoln researchers, industry partners, and local farmers to test and validate their technologies through the Spur Startup Sandbox Validation Program.',
    url:
      'https://siliconprairienews.com/2026/06/global-agtech-startups-choose-nebraska-in-new-spur-startup-sandbox-validation-program/',
  },

  {
    id: 'agtech-map',
    outlet: 'Silicon Prairie News',
    type: 'Ecosystem',
    date: 'May 26, 2026',
    title:
      'New AgTech Innovation Map Shows Nebraska’s Startup Ecosystem Getting Stronger Despite Few Exits',
    description:
      'The Nebraska AgTech Innovation Map, developed by Spur Ventures and The Combine, highlights a growing network of startups and support organizations across the state.',
    url:
      'https://siliconprairienews.com/2026/05/new-agtech-innovation-map-shows-nebraskas-startup-ecosystem-getting-stronger-despite-few-exits/',
  },

  {
    id: 'startup-playbook',
    outlet: 'AgTech Navigator',
    type: 'Analysis',
    date: 'January 28, 2026',
    title:
      'Why AgTech Start-Ups Failed Last Year — and a Playbook for 2026',
    description:
      'An analysis of the commercial, financial, and market-alignment challenges affecting AgTech startups, along with lessons for founders building stronger companies.',
    url:
      'https://www.agtechnavigator.com/Article/2026/01/28/why-agtech-start-ups-failed-last-year-and-a-playbook-for-2026/',
  },

  {
    id: 'business-models',
    outlet: 'Farming Future Food',
    type: 'Article',
    date: '2026',
    title:
      'Misaligned Business Models, Not Technology, Behind Recent AgTech Shutdowns',
    description:
      'A closer look at why promising agricultural technologies can struggle when pricing, customer needs, and business models are not properly aligned.',
    url:
      'https://farmingfuturefood.com/misaligned-business-models-not-technology-behind-recent-ag-tech-shutdowns/',
  },

  {
    id: 'farm-adoption',
    outlet: 'Silicon Prairie News',
    type: 'Feature',
    date: 'December 2025',
    title:
      'With Tough Times for Farms, AgTech Adoption Is No Easy Task — But Startups and Farmers See Potential',
    description:
      'Coverage of the inaugural Spur AgConverge conference and its farmer-led approach to evaluating agricultural technologies and adoption barriers.',
    url:
      'https://siliconprairienews.com/2025/12/with-tough-times-for-farms-agtech-adoption-is-no-easy-task-but-at-a-new-unl-conference-in-gothenburg-startups-and-farmers-see-potential/',
  },
];

const FeaturedPress = () => {
  const [activeMediaIndex, setActiveMediaIndex] =
    useState(0);

  const activeArticle =
    additionalCoverage[activeMediaIndex];

  const handleMediaKeyDown = (event, index) => {
    let nextIndex = index;

    if (
      event.key === 'ArrowRight' ||
      event.key === 'ArrowDown'
    ) {
      nextIndex =
        (index + 1) % additionalCoverage.length;
    } else if (
      event.key === 'ArrowLeft' ||
      event.key === 'ArrowUp'
    ) {
      nextIndex =
        (index - 1 + additionalCoverage.length) %
        additionalCoverage.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = additionalCoverage.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    setActiveMediaIndex(nextIndex);
  };

  return (
    <div className="home-media">
      {/* Main media highlight */}
      <article className="home-media-highlight">
        <div className="home-media-highlight-image">
          <img
            src={NebraskaTVImg}
            alt="Nebraska TV coverage of Spur AgConverge"
          />

          <div className="home-media-image-overlay" />

          <span className="home-media-video-badge">
            <i className="fas fa-play" />
            TV Report
          </span>

          <div className="home-media-image-caption">
            <span>Featured coverage</span>
            <strong>Nebraska TV</strong>
          </div>
        </div>

        <div className="home-media-highlight-content">
          <div className="home-media-highlight-meta">
            <span>Media Highlight</span>
            <span>2025</span>
          </div>

          <h3>
            Ag Industry Gathers in Gothenburg for
            Innovative Startup Program Launch
          </h3>

          <p>
            Nebraska TV highlighted the launch of Spur
            AgConverge and its work bringing farmers,
            startups, researchers, students, and agricultural
            industry leaders together around practical AgTech
            adoption.
          </p>

          <a
            href="https://nebraska.tv/news/local/ag-industry-gathers-in-gothenburg-for-innovative-startup-program-launch"
            target="_blank"
            rel="noopener noreferrer"
            className="home-media-primary-link"
          >
            <span>Watch the report</span>
            <i className="fas fa-external-link-alt" />
          </a>
        </div>
      </article>

      {/* Additional media coverage */}
      <div className="home-media-more">
        <div className="home-media-more-header">
          <div>
            <span className="home-media-more-kicker">
              More coverage
            </span>

            <h3>Latest Media Coverage</h3>
          </div>

          <Link
            to="/resources"
            className="home-media-view-all"
          >
            View all coverage
            <i className="fas fa-arrow-right" />
          </Link>
        </div>

        <div className="press-tabs">
          {/* Article tabs */}
          <div
            className="press-tabs-list"
            role="tablist"
            aria-label="Latest media coverage"
          >
            {additionalCoverage.map(
              (article, index) => {
                const isActive =
                  index === activeMediaIndex;

                return (
                  <button
                    type="button"
                    role="tab"
                    id={`home-press-tab-${article.id}`}
                    aria-controls={`home-press-panel-${article.id}`}
                    aria-selected={isActive}
                    tabIndex={isActive ? 0 : -1}
                    className={`press-tab ${isActive
                      ? 'press-tab-active'
                      : ''
                      }`}
                    onClick={() =>
                      setActiveMediaIndex(index)
                    }
                    onKeyDown={(event) =>
                      handleMediaKeyDown(
                        event,
                        index
                      )
                    }
                    key={article.id}
                  >
                    <span className="press-tab-number">
                      {String(index + 1).padStart(
                        2,
                        '0'
                      )}
                    </span>

                    <span className="press-tab-copy">
                      <span className="press-tab-outlet">
                        {article.outlet}
                      </span>

                      <strong>
                        {article.title}
                      </strong>

                      <span className="press-tab-date">
                        {article.date}
                      </span>
                    </span>

                    <span
                      className="press-tab-arrow"
                      aria-hidden="true"
                    >
                      <i className="fas fa-arrow-right" />
                    </span>
                  </button>
                );
              }
            )}
          </div>

          {/* Selected article */}
          <article
            className="press-feature-panel"
            role="tabpanel"
            id={`home-press-panel-${activeArticle.id}`}
            aria-labelledby={`home-press-tab-${activeArticle.id}`}
            key={activeArticle.id}
          >
            <span
              className="press-feature-watermark"
              aria-hidden="true"
            >
              {String(
                activeMediaIndex + 1
              ).padStart(2, '0')}
            </span>

            <div className="press-feature-top">
              <span className="press-feature-type">
                {activeArticle.type}
              </span>

              <span className="press-feature-date">
                {activeArticle.date}
              </span>
            </div>

            <div className="press-feature-content">
              <span className="press-feature-outlet">
                <i className="far fa-newspaper" />
                {activeArticle.outlet}
              </span>

              <h4>{activeArticle.title}</h4>

              <p>
                {activeArticle.description}
              </p>
            </div>

            <div className="press-feature-footer">
              <a
                href={activeArticle.url}
                target="_blank"
                rel="noopener noreferrer"
                className="press-feature-link"
              >
                Read full story
                <i className="fas fa-external-link-alt" />
              </a>

              <span className="press-feature-count">
                {String(
                  activeMediaIndex + 1
                ).padStart(2, '0')}

                <span>/</span>

                {String(
                  additionalCoverage.length
                ).padStart(2, '0')}
              </span>
            </div>
          </article>
        </div>
      </div>
    </div>
  );
};

export default FeaturedPress;